module.exports = __webpack_public_path__ + "img/photo.304bf6a9.jpeg";